export enum AccessType {
    CAPTCHA_OCC = 'CaptchaOccToken',
    CAPTCHA_MASHERY = 'CaptchaMasheryToken',
    OWNER_OCC = 'OwnerOccToken',
    OWNER_MASHERY = 'OwnerMasheryToken',
    USER_OCC = 'UserOccToken',
    USER_MASHERY = 'UserMasheryToken',
    NONE = 'none'
}
